import '../views/intradays/intradays.html';

export class IntradaysRouterStates {
    /** @ngInject */
    constructor($stateProvider) {
        this.$stateProvider = $stateProvider;
    }

    defineStates() {
        this.$stateProvider.state('app.intradays', {
            url: '/intradays',
            templateUrl: './app/views/intradays/intradays.html',
            controller: 'CommonViewController',
            controllerAs: 'vm',
            params: {
                pageTitle: 'REPORTINGS',
            }
        });
    }
}
